import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments';
import { ImpersonationService } from './impersonation.service';

export const IMPERSONATION_HEADER = 'X-Impersonate-Client-Employee';

/** Sends the impersonated client employee along with every API call. */
export function impersonationInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const clientEmployeeId = inject(ImpersonationService).clientEmployeeId();
  if (!clientEmployeeId || !req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  return next(req.clone({ headers: req.headers.set(IMPERSONATION_HEADER, clientEmployeeId) }));
}
